import { oldApiInstance } from 'functions/request';

export const fetchPromoMixItemsApi = ({ page, perPage }) => {
  return oldApiInstance.get(`/shop/mixed_coupons_and_on_sale_items?page=${page}&per_page=${perPage}`);
};
